export default __webpack_public_path__ + "static/Elements-429efbdcfb2a6987f7dc81479d5ccfcc.webm";